import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import SignInPage from "../SignInPage";
import SignUpPage from "../SignUpPage";

const AuthPage = () => {
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);

    useEffect(() => {
        const oauthData = {
            client_id: searchParams.get("client_id"),
            redirect_uri: searchParams.get("redirect_uri"),
            response_type: searchParams.get("response_type"),
            state: searchParams.get("state"),
        };

        if (oauthData.client_id || oauthData.redirect_uri) {
            sessionStorage.setItem("oauth_flow", JSON.stringify(oauthData));
        }
    }, [location.search]);

    const isSignIn = location.pathname.includes("sign-in");

    return isSignIn ? <SignInPage /> : <SignUpPage />;
};

export default AuthPage;
